import React, { Component } from 'react';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Paper,
  Checkbox,
  Button,
  Toolbar,
  Typography,
  Snackbar,
  CircularProgress,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { listBookings } from './../../ducks/selectors';
import { formatPeriod } from '../../lib/utils';
import api from '../../lib/api';
import AdminPageShell from '../../components/admin/AdminPageShell';

class Bookings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      orderBy: 'date',
      order: 'desc',
      selectedBookings: [],
      loading: false,
      snackbarOpen: false,
      snackbarMessage: '',
    };

    this.orderBy = this.orderBy.bind(this);
  }

  orderBy(field) {
    if (field === this.state.orderBy) {
      this.setState({ order: this.state.order === 'desc' ? 'asc' : 'desc' });
    } else {
      this.setState({ orderBy: field });
    }
  }

  handleSelectAll = (event) => {
    if (event.target.checked) {
      const { bookings } = this.props;
      this.setState({ selectedBookings: bookings.map(b => b.id) });
    } else {
      this.setState({ selectedBookings: [] });
    }
  };

  handleSelectBooking = (bookingId) => {
    const { selectedBookings } = this.state;
    const index = selectedBookings.indexOf(bookingId);
    if (index === -1) {
      this.setState({ selectedBookings: [...selectedBookings, bookingId] });
    } else {
      this.setState({ selectedBookings: selectedBookings.filter(id => id !== bookingId) });
    }
  };

  handleBulkCancel = async () => {
    const { selectedBookings } = this.state;
    if (selectedBookings.length === 0) return;

    if (!window.confirm(`Вы уверены, что хотите отменить ${selectedBookings.length} бронирований?`)) {
      return;
    }

    this.setState({ loading: true });
    try {
      const result = await api.bulkCancelBookings(selectedBookings);
      this.showSnackbar(`Отменено бронирований: ${result.canceledCount || result.CanceledCount || selectedBookings.length}`);
      this.setState({ selectedBookings: [] });
      // Перезагружаем данные
      window.location.reload();
    } catch (error) {
      this.showSnackbar(`Ошибка при отмене: ${error.message}`);
    } finally {
      this.setState({ loading: false });
    }
  };

  showSnackbar = (message) => {
    this.setState({ snackbarOpen: true, snackbarMessage: message });
  };

  handleCloseSnackbar = () => {
    this.setState({ snackbarOpen: false });
  };

  render() {
    const { bookings, classes } = this.props;
    const { selectedBookings, loading, snackbarOpen, snackbarMessage } = this.state;

    const orderedBookings = _.orderBy(bookings, [this.state.orderBy], [this.state.order]);
    const isAllSelected = selectedBookings.length > 0 && selectedBookings.length === bookings.length;
    const isIndeterminate = selectedBookings.length > 0 && selectedBookings.length < bookings.length;

    return (
      <AdminPageShell title="Бронирования">
        <div className={classes.pageBody}>
        <Paper className={classes.paper} elevation={2}>
          {selectedBookings.length > 0 && (
            <Toolbar className={classes.toolbar}>
              <Typography variant="h6" className={classes.title}>
                Выбрано: {selectedBookings.length}
              </Typography>
              <div className={classes.toolbarActions}>
                <Button
                  color="secondary"
                  variant="contained"
                  onClick={this.handleBulkCancel}
                  disabled={loading}
                  className={classes.button}
                >
                  {loading ? <CircularProgress size={20} /> : 'Отменить выбранные'}
                </Button>
              </div>
            </Toolbar>
          )}
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox">
                  <Checkbox
                    indeterminate={isIndeterminate}
                    checked={isAllSelected}
                    onChange={this.handleSelectAll}
                  />
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={this.state.orderBy === 'date'}
                    direction={this.state.order}
                    onClick={() => this.orderBy('date')}
                  >
                    Дата
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={this.state.orderBy === 'user'}
                    direction={this.state.order}
                    onClick={() => this.orderBy('user')}
                  >
                    Клиент
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={this.state.orderBy === 'price'}
                    direction={this.state.order}
                    onClick={() => this.orderBy('price')}
                  >
                    Цена
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={this.state.orderBy === 'center'}
                    direction={this.state.order}
                    onClick={() => this.orderBy('center')}
                  >
                    Спортивный центр
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={this.state.orderBy === 'playground'}
                    direction={this.state.order}
                    onClick={() => this.orderBy('playground')}
                  >
                    Площадка
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={this.state.orderBy === 'state'}
                    direction={this.state.order}
                    onClick={() => this.orderBy('state')}
                  >
                    Статус
                  </TableSortLabel>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {orderedBookings.map((booking) => {
                const intervals = booking.intervals ?
                  booking.intervals.map(time => time.interval) : [];
                const min = intervals.length > 0 ? Math.min(...intervals) : 0;
                const max = intervals.length > 0 ? Math.max(...intervals) : 0;
                const isSelected = selectedBookings.includes(booking.id);

                return (
                  <TableRow key={booking.id} selected={isSelected}>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={isSelected}
                        onChange={() => this.handleSelectBooking(booking.id)}
                      />
                    </TableCell>
                    <TableCell>
                      {moment(booking.date).format('DD.MM.YYYY')} {intervals.length ? formatPeriod(min, max + 1) : null}
                    </TableCell>
                    <TableCell>
                      {booking.user} {booking.phone}
                    </TableCell>
                    <TableCell>{booking.price}</TableCell>
                    <TableCell>{booking.center}</TableCell>
                    <TableCell>{booking.playground}</TableCell>
                    <TableCell>{booking.state}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Paper>

        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={this.handleCloseSnackbar}
          message={snackbarMessage}
        />
        </div>
      </AdminPageShell>
    );
  }
}

const styles = (theme) => ({
  paper: {
    width: '100%',
    overflowX: 'auto',
    flex: 1,
    marginTop: 0,
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    backgroundColor: '#ffffff',
    transition: 'box-shadow 0.3s ease',
    '&:hover': {
      boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
    },
  },
  pageBody: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    flex: 1,
    minHeight: 0,
  },
  toolbar: {
    backgroundColor: '#f8f9fa',
    borderRadius: 8,
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(2),
  },
  toolbarActions: {
    marginLeft: 'auto',
  },
  title: {
    flex: '1 1 100%',
    fontWeight: 600,
  },
  table: {
    '& thead th': {
      backgroundColor: '#f8f9fa',
      fontWeight: 600,
      fontSize: '0.875rem',
      color: '#495057',
      borderBottom: '2px solid #dee2e6',
    },
    '& tbody tr': {
      transition: 'background-color 0.2s ease',
      '&:hover': {
        backgroundColor: '#f8f9fa',
      },
    },
    '& tbody td': {
      borderBottom: '1px solid #e9ecef',
      padding: theme.spacing(1.5),
    },
  },
  button: {
    borderRadius: 8,
    padding: theme.spacing(1.25, 3),
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    '&:hover': {
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
    },
  },
});

const Styled = withStyles(styles)(Bookings);
export default connect(state => ({
  bookings: listBookings(state),
}))(Styled);
